import ImagesMissingBottleMissingBottleWebp from '@/public/images/missing-bottle/missing-bottle.webp';

export { ImagesMissingBottleMissingBottleWebp };
